module.exports = __webpack_public_path__ + "static/media/azure.5eb85183.png";